/* eslint-disable */
/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: AI 任务相关请求
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-11-24 17:21:44
 */
import fetchHelper from '../utils/fetchHelper'
import exceptionHelper from '../utils/exceptionHelper'
import { captureFetchException } from '../utils/sentryUtils'

/**
 * 生成 POST 请求的 redux-thunk action
 * @param {string} path API 路径
 */
const createPostAction = (path) => (data) => (dispatch, getState) => {
  const config = {
    url: __API_SERVER_HOST__ + path,
    arguments: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }
  }

  return fetchHelper(dispatch, getState, config)
    .then((result) => {
      return Promise.resolve(result)
    })
    .catch((err) => {
      captureFetchException(err, config)
      return Promise.reject(err || null)
    })
}

/**
 * 创建 AI 任务
 */
export const createAITask = createPostAction('/web/ai/task/create')

/**
 * 查询 AI 任务状态
 */
export const queryAITask = createPostAction('/web/ai/task/query')

/**
 * 取消 AI 任务
 */
export const cancelAITask = createPostAction('/web/ai/task/cancel')

/**
 * 同步 AI 任务
 */
export const syncTask = createPostAction('/web/agent/sync/task')
